import { useEffect, useMemo } from "react";
import Layout from "../../components/Layout";
import classes from "./styles.module.scss";
import { Heading } from "@chakra-ui/react";
import { PLAY_STORE_URL } from "../../config";
import { useRouter } from "next/router";
import queryString from "query-string";

export default function Referral() {
  const router = useRouter();

  const params = useMemo(() => {
    if (typeof window !== "undefined") {
      return Object.fromEntries(new URLSearchParams(window.location.search));
    }
    return {};
  }, [router.asPath]);

  const referralUrl = useMemo(() => {
    if (Object.keys(params).length === 0) {
      return PLAY_STORE_URL;
    }

    const cleanedParams = removeNullValues(params);
    const decodedReferrer = cleanedParams?.referrer?.replaceAll("&", " ");

    const payload = {
      ...cleanedParams,
      referrer: decodedReferrer?.trim() === "" ? "--" : decodedReferrer,
    };

    const encodedParams = encodeURIComponent(queryString.stringify(payload));

    return `${PLAY_STORE_URL}&referrer=${encodedParams}`;
  }, [params]);

  useEffect(() => {
    if (referralUrl && !referralUrl.endsWith("&referrer=")) {
      window.location.href = referralUrl;
    }
  }, [referralUrl]);

  return (
    <Layout>
      <div className={classes.Referral}>
        <Heading as="h1">Redirecting...</Heading>
      </div>
    </Layout>
  );
}

function removeNullValues(obj) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
}
